import React from 'react';
import PropTypes from 'prop-types';
import { classNameWithModifiers as withMods } from 'helpers/class-name';

import './StatusBox.scss';

const StatusBox = ({ children, className, isDisabled }) => (
  <span className={withMods('status-box', { isDisabled }, className)}>{children}</span>
);

StatusBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default StatusBox;
